import { render, staticRenderFns } from "./CompetitionTabs.vue?vue&type=template&id=63df7474&scoped=true"
import script from "./CompetitionTabs.vue?vue&type=script&lang=js"
export * from "./CompetitionTabs.vue?vue&type=script&lang=js"
import style0 from "./CompetitionTabs.vue?vue&type=style&index=0&id=63df7474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df7474",
  null
  
)

export default component.exports